<template>
  <div class="menu-upload-icon-container">
    <el-tooltip content="建议上传大小：135*135px" placement="top" class="tooltip">
      <span class="fa fa-question-circle inline-span"></span>
    </el-tooltip>
    <el-upload
      class="upload"
      action=""
      :http-request="uploadFile"
      :before-upload="beforeAvatarUpload"
      :headers="headers"
      :show-file-list="false"
      name="image"
      :data="{type: 'SYSTEM'}">
      <div class="upload-click">
        <span class="update">  <i class="el-icon-plus "></i></span>
        <img v-if="data.appIcon" :src="getDownLoadUrl(data.appIcon)" alt="图片失效">
        <img v-else :src="icon" alt="图片失效">
      </div>
      <div class="upload-btn">
      </div>
    </el-upload>
  </div>
</template>

<script>
import icon from '@/store/process/assets/icon.png'
import tokenStorage from '@/plugins/tokenStorage'
export default {
  name: 'menu-upload-icon',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      uploadUrl: '/shared-api/files/uploadFiles',
      headers: {'Authorization': tokenStorage.getToken()},
      icon,
      uploading: false
    }
  },
  methods: {
    beforeAvatarUpload (file) {
      let type = file.type
      let result = true
      if (type !== 'image/jpeg' && type !== 'image/png') {
        this.$message.error('上传头像图片只能是 jpg 或 png 格式!')
        result = false
      } else {
        if (file.size / 1024 / 1024 > 2) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          result = false
        }
      }
      return result
    },
    uploadFile (files) {
      let file = files.file
      // 为了防止正在上传的时候点击保存没有保存上
      this.uploading = true
      this.$upload({file}).then(res => {
        this.$emit('uploadFile', `/${res.key}`)
        this.$nextTick(() => { this.uploading = false })
      })
    }
  },
  computed: {
    getDownLoadUrl () {
      return url => `${sessionStorage.getItem('ossDownloadUrl')}${url}`
    }
  }
}
</script>

<style lang="scss">
.menu-upload-icon-container {
  display: flex;
  align-items: center;
  .inline-span {
    display: inline-block;
    position: absolute;
    top: 6px;
  }
  .upload {
    width: 44px;
    height: 44px;
    line-height: 44px;
    margin-left: 20px;
    display: inline-block;
    .el-upload {
      width: 44px;
      height: 44px;
      .upload-click {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        .update {
          display: none;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, .5);
          color: #fff;
          border-radius: 50%;
          z-index: 10;
        }
        &:hover {
          .update {
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system/system/menu/menu-upload-icon.vue